import ForgotPassword from 'pages/auth/forgot-password'
import Login from 'pages/auth/login'
import ResetPassword from 'pages/auth/reset-password'

import { routes } from 'utils/routes'

const PublicRoutes = [
  { path: `${routes.login}`, exact: true, name: 'Login', component: Login },
  {
    path: `${routes.forgotPassword}`,
    exact: true,
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  { path: `${routes.resetPassword}`, exact: true, name: 'ResetPassword', component: ResetPassword }
]

export default PublicRoutes
